const strings = {
  INITIAL_ERRORS: {INITIAL: 0},
  required: 'Esse campo é obrigatório',
  invalid_code: 'CNPJ inválido',
  invalid_full_name: 'Digite seu nome completo',
  invalid_name: 'O nome deve ter pelo menos 3 caracteres',
  invalid_name_max: 'O nome deve ter no máximo 50 caracteres',
  invalid_cpf: 'CPF inválido',
  invalid_rg: 'RG inválido',
  invalid_manufacturer: 'Fabricante inválido',
  invalid_uf: 'UF inválido',
  invalid_cep: 'Ops... CEP inválido',
  invalid_date: 'Data inválida',
  invalid_street: 'Essa rua é inválida',
  invalid_city: 'Essa cidade é inválida',
  invalid_email: 'Ops... E-mail inválido',
  invalid_district: 'Ops... Bairro inválido',
  invalid_modality: 'Ops... Modalidade inválida',
  invalid_phone: 'Ops... Esse telefone é inválido',
  invalid_complement: 'Esse complemento é inválido',
  invalid_number: 'O número deve ser maior que zero',
  invalid_value: 'Esse valor é inválido',
  invalid_card_code: 'Código de segurança inválido',
  invalid_card: 'Cartão inválido',

  email_exists: 'Desculpe, esse e-mail já está sendo utilizado',
  invalid_local: 'Local inválido, deve ter menos que 100 caracteres',
};

export default strings;
